<template>
  <div class="app-wrapper" ref="wrapper">
    <div class="vertical-layout">
      <SizeWidth :box="wrapper" :minWidth="600" :maxWidth="10000" style="z-index: 100">
        <ModerationMenuPanelSide>
          <ModerationMenuSocialJet />
          <template #menu>
            <ModerationMenuSide />
          </template>
          <template #links>
            <ModerationMenuLinks />
          </template>
        </ModerationMenuPanelSide>
      </SizeWidth>
      <div v-if="!isDesktop && isMobileMenuOpened" class="pt-16">
        <ModerationMenuPanelSide>
          <template #menu>
            <ModerationMenuSide />
          </template>
        </ModerationMenuPanelSide>
      </div>
      <div class="page-with-top-panel">
        <PublisherMenuPanelTop>
          <div class="gorizontal-menu flex items-center md:flex-center justify-between">
            <div v-if="isDesktop" class="ml-28 text-[#3A3D44] font-bold text-2xl">
              {{ routesNormalNames[route.name as keyof typeof routesNormalNames] || route.name }}
            </div>
            <SizeWidth :box="wrapper" :minWidth="0" :maxWidth="599" classes="!w-full">
              <div class="!w-full h-[60px] flex justify-between items-center">
                <div>
                  <img
                    src="/public/assets/img/svg/mobile_menu.svg"
                    alt="mobile_menu"
                    class="cursor-pointer hover:opacity-50"
                    @click="isMobileMenuOpened = !isMobileMenuOpened"
                  />
                </div>
                <div class="text-[#3A3D44] font-bold text-2xl flex-1 text-center">
                  {{
                    routesNormalNames[route.name as keyof typeof routesNormalNames] || route.name
                  }}
                </div>
                <!-- <div class="flex justify-end gap-3">
                  <div class="mt-2 mr-1">
                    <i class="fi fi-sr-credit-card text-[25px] text-[#A1A1A1] mt-2"></i>
                  </div>
                  <div>
                    <Icon
                      name="solar:bell-bold"
                      width="30"
                      height="30"
                      size="30"
                      class="text-[#A1A1A1] !w-[30px] mt-1"
                    />
                  </div>
                  <div>
                    <img
                      src="/assets/img/user.png"
                      alt="logo"
                      class="rounded-full w-[40px] h-[40px]"
                    />
                  </div>
                </div> -->
              </div>
            </SizeWidth>
            <SizeWidth :box="wrapper" :minWidth="600" :maxWidth="10000">
              <div class="flex align-center justify-between">
                <template v-if="userModule.id">
                  <div
                    class="border-l border-l-[#d8f2fa] h-14 flex items-center justify-center px-[24px] relative"
                  >
                    <Icon
                      name="solar:bell-bold"
                      color="#efefef"
                      width="20"
                      height="20"
                      size="25"
                      class="text-[#A1A1A1] cursor-pointer"
                      @click="navigateTo('/moderation/support')"
                    />
                    <div
                      class="w-5 h-5 rounded-full bg-[#27C2A7] absolute bottom-2 right-2 flex items-center justify-center"
                      v-if="+moderationModule.dialogCount > 0"
                    >
                      <span class="text-white text-xs font-bold">{{
                        moderationModule.dialogCount
                      }}</span>
                    </div>
                  </div>

                  <div
                    class="border-l border-l-[#d8f2fa] h-14 flex items-center justify-center px-[24px] cursor-pointer relative"
                    @click="openUserMenu"
                  >
                    <img src="/assets/img/user.png" alt="logo" class="rounded-full mr-2" />
                    <span class="text-[#A1A1A1] font-bold">{{
                      userName || telegram || email || "Имя пользователя"
                    }}</span>
                    <Icon
                      name="fa:chevron-down"
                      width="10"
                      height="10"
                      class="ml-2 cursor-pointer font-[200] text-[10px] text-[#A1A1A1] -rotate-90"
                      :class="{ 'rotate-0': userMenuVisible }"
                    />
                    <Transition name="fade">
                      <div
                        v-if="userMenuVisible"
                        class="absolute top-12 left-0 w-full bg-black bg-opacity-50 rounded-lg py-2 px-4 flex flex-col gap-y-3 z-50"
                        v-click-outside="
                          () => {
                            userMenuVisible = false;
                          }
                        "
                        @click.stop
                      >
                        <NuxtLink to="/publisher" class="text-white cursor-pointer"
                          >Паблишер</NuxtLink
                        >
                        <NuxtLink to="/adv" class="text-white cursor-pointer">Рекл</NuxtLink>
                        <div class="text-white cursor-pointer" @click="logout">Выйти</div>
                      </div>
                    </Transition>
                  </div>
                </template>
                <NuxtLink v-else to="/">
                  <UIButtonSecondary class="gorizontal-menu__aside-enter" type="button">
                    Войти
                  </UIButtonSecondary>
                </NuxtLink>
              </div>
            </SizeWidth>
          </div>
        </PublisherMenuPanelTop>
        <div class="page-self md:pl-16">
          <!-- основной слот для страницы -->
          <slot v-if="accessChecked" />
        </div>
      </div>
    </div>

    <UIOverlay :view-overlay="true" />
    <ElDialog
      v-model="userModule.loginDialogVisible"
      modal-class="authorize-modal"
      width="min(500px,85vw)"
    >
      <LoginScreen />
    </ElDialog>

    <!-- Debug панель для Telegram WebView -->
    <TelegramDebugPanel />
  </div>
</template>
<script setup lang="ts">
  import { IconColor } from "~/interfaces/publisher";
  import { usePublisherStore } from "~/store/PublisherModule";
  import { useAppStore } from "~/store/AppModule";
  import { useChannelStore } from "~/store/ChannelModule";
  import { useAdvertContentStore } from "~/store/AdvertContentModule";
  import { useAdvertStore } from "~/store/AdvertModule";
  import { useModerationStore } from "~/store/ModerationModule";
  import { useScreenSize } from "~/helpers/isMobile";

  const { isDesktop } = useScreenSize();

  const isMobileMenuOpened = ref(false);

  const route = useRoute();

  watch(() => route.name, () => {
    nextTick(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  // Stores
  const userModule = usePublisherStore();
  const channelModule = useChannelStore();
  const advertContentModule = useAdvertContentStore();
  const appModule = useAppStore();
  const advertModule = useAdvertStore();
  const moderationModule = useModerationStore();

  // Reference to a DOM element
  const wrapper = ref<HTMLElement | null>(null);

  // Запросить токен для пользователя
  onMounted(() => {
    userModule.requestAuthKey();
    checkAdminAccess();
  });

  const userName = computed(() => userModule.name ?? null);
  const telegram = computed(() => userModule.telegram ?? null);
  const email = computed(() => userModule.email ?? null);

  const userMenuVisible = ref(false);
  const openUserMenu = () => {
    userMenuVisible.value = !userMenuVisible.value;
  };

  const logout = () => {
    userModule.logout();
    navigateTo("/");
  };

  const routesNormalNames = computed(() => ({
    moderation: "Модерация",
    "moderation-clients": "Рекламодатели",
    "moderation-publishers": "Паблишеры",
    "moderation-orders": "Заказы",
    "moderation-publications": "Публикации",
    "moderation-statistics": "Статистика",
    "moderation-channels": "Каналы",
    "moderation-settings": "Настройки",
    "moderation-support": "Поддержка",
    "moderation-import": "Импорт",
    "moderation-blog": "Блог",
    "moderation-blog-create": "Новая статья",
    "moderation-blog-id": "Редактирование статьи",
  }));

  const isAdmin = computed(() => userModule.roles.includes(4) || userModule.roles.includes(2));
  // Роли из стора уже админские — страницу показываем сразу, права уточняем фоном
  const accessChecked = ref(isAdmin.value);

  // Роли в сторе могут быть устаревшими, поэтому права перед входом берём с сервера.
  // На 404 уводим, только если сервер подтвердил, что доступа нет
  const checkAdminAccess = async () => {
    if (!userModule.authorized) {
      navigateTo("/404");
      return;
    }
    try {
      await userModule.refreshUserInfo();
    } catch (error) {
      // Сервер права не подтвердил и не опроверг — не выгоняем. Если токен протух,
      // simpleApi уже разлогинил и отправил на вход
      console.error("checkAdminAccess", error);
      if (userModule.authorized) accessChecked.value = true;
      return;
    }
    if (!isAdmin.value) {
      navigateTo("/404");
      return;
    }
    accessChecked.value = true;
  };

  // // Make stores available in the global window object (not recommended in production)
  // window.userModule = userModule;
  // window.channelModule = channelModule;
  // window.advertContentModule = advertContentModule;
  // window.appModule = appModule;
  // window.advertModule = advertModule;
</script>

<style lang="scss">
  .app-wrapper {
    min-height: 100dvh;
  }

  .vertical-layout {
    display: flex;
    flex-direction: row;
  }

  .page-with-top-panel {
    width: 100%;
    flex-grow: 1;
  }

  .gorizontal-menu,
  .vertical-menu {
    background: $white;
  }

  .el-menu + .screen-wrapper {
    margin-left: 70px;

    @media (max-width: $small-width) {
      margin-left: 0;
    }
  }

  .gorizontal-menu {
    @apply w-full pr-4 pl-2 z-50;
    height: 70px;

    &__aside {
      @apply h-full justify-end;

      &-user {
        width: fit-content;
        color: $light-gray;
        font-weight: 500;
      }

      &-notifications {
        width: fit-content;
        height: 100%;
        padding-left: clamp(20px, 2vw, 24px);
        padding-right: clamp(20px, 2vw, 24px);
        border-left: 1px solid rgba($main, 0.3);
        // border-right: 1px solid rgba($main, 0.3);

        @media (max-width: $small-width) {
          border: none;
        }
      }
    }

    &__button {
      cursor: pointer;
      margin: 6px 0px;
      width: 36px;
      height: 36px;
      border-radius: 11px;
      border: 1px solid rgba($main, 0.2);
      flex-direction: column;
      gap: 5px;
      padding-left: 8px;
      padding-right: 8px;

      > div {
        width: 100%;
        height: 2px;
        background: $main;
        border-radius: 1px;
      }
    }
  }

  .gorizontal-menu .gorizontal-menu__button {
    display: none;
  }

  @media (max-width: $small-width) {
    .app-wrapper .vertical-menu.vertical-menu.el-menu--collapse {
      border-right: none;

      &:not(.horizontal-collapse-transition) {
        transform: translateX(-300px);
      }

      img {
        display: none;
      }
    }

    .gorizontal-menu .gorizontal-menu__button {
      display: flex;

      + a {
        z-index: 1;
      }
    }

    .gorizontal-menu {
      justify-content: space-between;
    }

    @keyframes close {
      to {
        transform: translateX(-300px);
      }
    }

    .vertical-menu:not(.el-menu--collapse).v-leave-active {
      animation: close 0.4s ease-in;
    }
  }

  button.gorizontal-menu__aside-enter {
    @apply px-3;
    max-width: min(35vw, 8rem);
  }
</style>
